import { IRoleCrudModalLang } from '../../../types/lang'

export const roleCrudModalLang: IRoleCrudModalLang = {
	role_crud_modal: {
		title_create: 'Create role',
		title_edit: 'Edit role',
		title_clone: 'Clone role from base role',
		title_remove_single: 'Remove <span>role</span>',
		title_remove_multiple: 'Remove <span>roles</span>',
		title_remove_multiple_cnt: 'Remove <span>{{cnt}} selected role(s)</span>',
		title_not_remove_multiple_cnt: 'Will NOT be removed <span>{{cnt}} selected role(s) (SYSTEM)</span>',
		field_code_label: 'Code',
		field_code_placeholder: 'Code',
		field_name_label: 'Name',
		field_name_placeholder: 'Name',
		field_is_system_label: 'System',
		field_is_buyer_label: 'Buyer',
		field_in_group_label: 'In group',
		field_in_group_placeholder: 'In group',
		field_is_team_label: 'Is team',
		field_is_team_placeholder: 'Is team',
		field_team_report_label: 'Team Report',
		field_team_report_placeholder: 'Team Report',
		field_notes_label: 'Notes',
		field_notes_placeholder: 'Notes',
		msg_remove_confirm: 'Are you sure?',
		btn_create: 'Create',
		btn_update: 'Save',
		btn_clone: 'Clone',
		btn_remove: 'Remove',
		btn_close: 'Close'
	}
}